/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { TourCheckoutResponse } from '../../models/tour-checkout-response';

export interface PostToursCheckout$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The tour key
 */
  tourKey: KeyType;
}

export function postToursCheckout(http: HttpClient, rootUrl: string, params: PostToursCheckout$Params, context?: HttpContext): Observable<StrictHttpResponse<TourCheckoutResponse>> {
  const rb = new RequestBuilder(rootUrl, postToursCheckout.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('tourKey', params.tourKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TourCheckoutResponse>;
    })
  );
}

postToursCheckout.PATH = '/organization-sites/{organizationSiteKey}/carrier/tours/{tourKey}/checkout';
